import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CourseDetails = ({ formData }) => {
  const token = localStorage.getItem('token');
  const [courseFeesData, setCourseFeesData] = useState({});
  const [courseDurData, setCourseDurData] = useState({});

  useEffect(() => {
    if (!token) return;
    const fetchCourses = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/course`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const fees = {};
        const dur = {};

        res.data.forEach((course) => {
          fees[course.courseName] = course.courseFees;
          dur[course.courseName] = course.courseDuration;
        });

        setCourseFeesData(fees);
        setCourseDurData(dur);
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
    };

    fetchCourses();
  }, [token]);

  return (
    <div className="form-section">
      <div className="section-content">

        {/* Course Type */}
                <div className="form-row">
        <div className="form-group">
          <label className="label">
            Course Type <span className="mandatory">*</span>
          </label>
          <input
            type="text"
            name="courseType"
            value={formData.courseType || ''}
            readOnly
            className="input"
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
          />
        </div>

        {/* Course Name */}
        <div className="form-group">
          <label className="label">
            Course Name <span className="mandatory">*</span>
          </label>
          <input
            type="text"
            name="courseName"
            value={formData.courseName || ''}
            readOnly
            className="input"
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
          />
        </div>
        </div>

        {/* Start and End Dates */}
        <div className="form-row">
          <div className="form-group">
            <label className="label">Course Start Date</label>
            <input
              type="date"
              value={formData.courseStartDate || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>

          <div className="form-group">
            <label className="label">Course End Date</label>
            <input
              type="date"
              value={formData.courseEndDate || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>
        </div>

        {/* Learning Mode */}
                <div className="form-row">
        <div className="form-group">
          <label className="label">Learning Mode</label>
          <input
            type="text"
            value={formData.learningMode || ''}
            readOnly
            className="input"
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
          />
        </div>

        {/* Batch */}
        <div className="form-group">
          <label className="label">Batch</label>
          <input
            type="text"
            value={formData.batch || ''}
            readOnly
            className="input"
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
          />
        </div>
        </div>

        {/* Custom Batch */}
        {formData.batch === 'Others' && (
          <div className="form-group full-width">
            <label className="label">Custom Batch</label>
            <input
              type="text"
              value={formData.customBatch || ''}
              readOnly
              className="input"
              style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
            />
          </div>
        )}
      </div>
      
    </div>
  );
};

export default CourseDetails;
